import { render, staticRenderFns } from "./TextLongItem.vue?vue&type=template&id=4e80341e&"
import script from "./TextLongItem.vue?vue&type=script&lang=js&"
export * from "./TextLongItem.vue?vue&type=script&lang=js&"
import style0 from "./TextLongItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports